'use strict';

var WestoryWidgetManager = (function(){
    'use strict';

    function WestoryWidgetManager(){
        if(!(this instanceof WestoryWidgetManager)) {
            return new WestoryWidgetManager();
        }
    }

    WestoryWidgetManager.prototype.init = function(){
        var $body = $('body');

        $body.on('click', 'a[data-ajax]', {WidgetManager:this}, function(evt){
            evt.preventDefault();
            evt.stopPropagation();

            evt.data.WidgetManager.manageAjaxAction(this);

            return false;
        });

        $('.bubble-modal-wrapper').each(function(index, el) {
            BubbleModalWrapper.createComponent($(el));
        });

        $('.slider').each(function(index, el) {
            Slider.createComponent($(el));
        });

    };

    WestoryWidgetManager.prototype.manageAjaxAction = function(elem)
    {
        var nodeName = $(elem).get(0).nodeName.toLowerCase();
        var url;
        switch(nodeName){
            case 'input':
                url = $(elem).data('url');
                break;
            case 'form':
                url = $(elem).attr('action');
                break;
            default:
                url = $(elem).attr('href');
                break;
        }
        if(nodeName == 'form'){
            var postData = $(elem).serialize();
            $.post(url, postData, function(data){
                if(data.success == 1){
                    if ($(this.elem).data('special') != null) {
                        this.WidgetManager.manageSpecialActions(this.elem, data);
                    }
                }
            }.bind({elem: elem, WidgetManager: this}));
        }else {
            $.get(url, function (data) {
                if ($(this.elem).data('special') != null) {
                    this.WidgetManager.manageSpecialActions(this.elem, data);
                }

                if (data.success == 1) {


                    var cssClass = 'active';
                    if ($(this.elem).data('ajaxClass') != null) {
                        cssClass = $(this.elem).data('ajaxClass');
                    }
                    var nodeName = $(this.elem).get(0).nodeName.toLowerCase();

                    // find similar object with the same ajax-identifier
                    var similars = $('a[data-ajax-identifier=' + $(this.elem).data('ajax-identifier')+']');
                    if(nodeName == 'a'){

                        if (data.statut == 1) {

                            //change all similar object
                            similars.each(function(){
                                var cssClass = 'active';
                                if ($(this).data('ajaxClass') != null) {
                                    cssClass = $(this).data('ajaxClass');
                                }
                                $(this).addClass(cssClass);
                                $(this).find('.picto-block-bd').addClass(cssClass);
                                $(this).attr('href', data.new_url);
                            });

                            // change current object
                            $(this.elem).addClass(cssClass);
                            $(this.elem).find('.picto-block-bd').addClass(cssClass);
                        } else {
                            //change all similar object
                            similars.each(function(){
                                var cssClass = 'active';
                                if ($(this).data('ajaxClass') != null) {
                                    cssClass = 'selected';
                                }
                                $(this).removeClass(cssClass);
                                $(this).find('.picto-block-bd').removeClass(cssClass);
                                $(this).attr('href', data.new_url);
                            });

                            // change current object
                            $(this.elem).removeClass(cssClass);
                            $(this.elem).find('.picto-block-bd').removeClass(cssClass);
                        }
                        //change current object href
                        $(this.elem).attr('href', data.new_url);
                        if(typeof data.counter != 'undefined'){
                            if($(this.elem).find('[data-counter]').length > 0){
                                $(this.elem).find('[data-counter]').html(data.counter);
                            }
                        }
                    }

                    if ($(this.elem).data('special') != null) {
                        this.WidgetManager.manageSpecialActions(this.elem, data);
                    }
                }
            }.bind({elem: elem, WidgetManager: this}));
        }
    };

    WestoryWidgetManager.prototype.manageSpecialActions = function(elem, data)
    {
        var specialAction = $(elem).data('special');
        switch(specialAction){
            case 'reload_page':
                window.location.reload(true);
                break;
        }
    };

    return WestoryWidgetManager;
}());

window.WsWidgetManager = new WestoryWidgetManager();

$(function() {
    window.WsWidgetManager.init();

    var $document = $(document);

    $document.tooltip({
        items:'[data-tooltip]',
        content: function(){
            return $(this).attr('data-tooltip');
        },
        position:{my:"center top+8", at: "center bottom", collision: "none"}
    });

});